import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

const namespace = 'rpd'

export type ObjectStoreFile = {
  name: string
  key: string
  size: number
  lastModified: string
  downloadUrl: string
}

// The API answers in S3 listing order, so the newest-first ordering the reports table
// relies on has to be applied here.
export const listFiles = async ({ dir, signal }: { dir: string; signal?: AbortSignal }) => {
  const response = await apiClient.get(
    `${endpoints.objectStore}/${namespace}/${encodeURIComponent(dir)}`,
    { signal },
  )
  return unwrapCollection<ObjectStoreFile>(response).sort(
    (a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime(),
  )
}
